module.exports = __webpack_public_path__ + "img/bankid.80ddf34d.png";